module.exports = __webpack_public_path__ + "static/media/ribbon.a46afc79.png";